import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

let refreshing: Promise<unknown> | null = null;
const NO_RETRY = ["/auth/refresh", "/auth/login", "/auth/google", "/auth/venue/register", "/auth/logout", "/auth/register", "/auth/password"];

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config;
    const url: string = cfg?.url || "";
    if (err.response?.status === 401 && cfg && !cfg._retry && !NO_RETRY.some((p) => url.includes(p))) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(cfg);
      } catch {
        refreshing = null;
      }
    }
    return Promise.reject(err);
  }
);

export function errorText(e: any, t: (k: string) => string): string {
  const detail = e?.response?.data?.detail;
  const tr = (m: string) => { const x = t(`err.${m}`); return x.startsWith("err.") ? m : x; };
  if (typeof detail === "string") return tr(detail);
  if (Array.isArray(detail)) return detail.map((d) => tr(String(d?.msg || "").replace(/^Value error, /, ""))).filter(Boolean).join(" ");
  return t("common.error");
}
